<template>
  <b-container fluid>
    <!-- <b-row>
        <b-col class="mb-4 mt-3">
            <h4><b-icon icon="credit-card-fill"/> Registro de pagos externos </h4>
        </b-col>
    </b-row> -->
    <b-row>
      <b-col cols="12" lg="6" class="mt-3">
        Canal de pago:
       <b-form-select v-model="canalPago" :options="servicios"></b-form-select>
      </b-col>
      <b-col cols="12" lg="6" class="mt-3">
        Registrar pagos por:
       <b-form-select v-model="tipoRegistro" :options="tiposRegistro"></b-form-select>
      </b-col>
      <b-col cols="12"  class="mt-3">
        Seleccione el archivo a importar
        <b-form-file v-model="file" @change="getBase64"></b-form-file>
      </b-col>
      <b-col cols="12"  class="mt-4">
        <b-button  block variant="success"  @click="enviarLayout">Registrar pagos <b-spinner v-if="procesando"/></b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-textarea
          v-model="this.resultados"
          rows="3"
          max-rows="10"
          disabled
        ></b-form-textarea>
      </b-col>
    </b-row>
    
  </b-container>
</template>


<script>

import axios from 'axios'
import { server2, checkAuth, getPostConfig, handledError } from '@/axios-tools'
import {getBase64 } from '@/vue-tools'
import { mapState} from 'vuex'

export default {
  computed:{
   ...mapState({
      servicios: state => state.cobro.catalogCobro.serviciosRecaudacion,
      archivoB64: state => state.cobro.archivoB64,
      token: state => state.login.token,
    }),
  },
  data(){
    return{
      canalPago:'',
      tipoRegistro:'Línea de captura',
      tiposRegistro:['Línea de captura', 'Folio de la orden de pago', 'ID de la transacción'],
      procesando : false,
      resultados : '',
      file : null
    }
  },
  components: {
  },
  methods:{
    getBase64(evt){
      this.resultados = "";
      /* Método que obtiene la representación en base64 de un archivo y lo guarda en el Array 'archivosB64' */
      getBase64(evt.target.files[0], this.$store);
      
    },
    enviarLayout(){
      if(!this.procesando && this.archivoB64.contenido!=null && this.archivoB64.contenido!='' && checkAuth(this.$router, this.$store)){
            this.procesando = true;
            this.resultados = '';
            let r ={
              base64: this.archivoB64.contenido,
              extension : this.archivoB64.tipo,
              tipoLayout : this.tipoRegistro,
              op1 : this.canalPago
            }
	
            axios(
                getPostConfig(server2.cargapagosreferencia, r, this.token, {})
                
            )
            .then(res => {
                this.resultados = res.data;
                this.procesando = false;
                this.$store.commit("updateArchivoB64", {contenido:'', nombre:'', tipo:''});
                this.file =null;

            }).catch(err => {
                this.$store.commit("updateArchivoB64", {contenido:'', nombre:'', tipo:''});
                this.resultados = "";
                this.procesando = false;
                this.file =null;
                handledError(err, server2.cargapagosreferencia, this.$router, this.$store);
            });
        }
    }

  },
   
  
}

</script>
<style>
  
</style>